export default "__VITE_ASSET__12b251bb__"